import React from "react";
import { View } from "react-native";
import { useTheme } from "styled-components/native";
import styled, { css } from "styled-components/native";
import { ProductCategory } from "@utils/constants";
import PDPGalleryView from "../utils/PDPGalleryView";

interface PdpGalleryProps {
  // Data
  receivedDiamondData: any;
  itemDetail: any;
  productType: ProductCategory;
  fromComponent?: boolean;

  // Layout
  screenWidth: number;
  contentWidth: number;
  sizes: {
    imageWidth: number;
    spacing: number;
    thumbSize?: number;
    iconSize?: number;
  };

  // State (for mobile)
  setMediaActiveIndex?: (index: number) => void;
  mediaActiveIndex?: number;

  // Layout handler (for mobile)
  onGalleryLayout?: (e: any) => void;
  shouldShowJewelryComponents: (item: any) => boolean;
  isModal?: boolean;
  fromReviewPage?: boolean;

  // Remove failed media from itemDetail.media
  onRemoveMedia?: (index: number, media_id: number) => void;
}

const PdpGallery = ({
  receivedDiamondData,
  itemDetail,
  productType,
  fromComponent,
  screenWidth,
  contentWidth,
  sizes,
  setMediaActiveIndex,
  mediaActiveIndex,
  onGalleryLayout,
  isModal,
  fromReviewPage,
  onRemoveMedia,
}: PdpGalleryProps) => {
  const theme = useTheme();

  // Desktop gallery (left side, fixed/sticky)
  if (!theme.isMobile) {
    return (
      <FixedGalleryView>
        <FixedSetGalleryView>
          <FixedContentGalleryViewLeft>
            <PDPGalleryView
              ReceivedDiamondData={receivedDiamondData}
              itemDetail={itemDetail}
              productType={productType}
              screenWidth={screenWidth}
              imageWidth={
                theme.isLargeScreen
                  ? sizes.imageWidth
                  : Math.max(0, contentWidth - 474)
              }
              dimensions={sizes}
              showExpandButton
              onRemoveMedia={onRemoveMedia}
              isJewelryComponent={fromComponent}
              fromReviewPage={fromComponent ? fromComponent : fromReviewPage}
              isModal={isModal}
            />
          </FixedContentGalleryViewLeft>
        </FixedSetGalleryView>
      </FixedGalleryView>
    );
  }

  // Mobile gallery (full width, scrollable)
  return (
    <View style={{ flex: 1 }} onLayout={onGalleryLayout}>
      <PDPGalleryView
        ReceivedDiamondData={receivedDiamondData}
        itemDetail={itemDetail}
        productType={productType}
        screenWidth={screenWidth}
        imageWidth={contentWidth}
        setMediaActiveIndex={setMediaActiveIndex}
        mediaActiveIndex={mediaActiveIndex}
        isJewelryComponent={fromComponent}
        fromReviewPage={fromComponent ? fromComponent : fromReviewPage}
        onRemoveMedia={onRemoveMedia}
        isModal={isModal}
      />
    </View>
  );
};

const FixedGalleryView = styled.View`
  width: 50%;
  height: 100%;
`;

const FixedSetGalleryView = styled.View`
  align-self: flex-end;
  position: sticky;
  top: 0;
`;

const FixedContentGalleryViewLeft = styled.View<any>`
  max-width: ${({ theme }) => (theme.isTablet ? "375px" : "auto")};
  align-items: flex-end;
  ${({ theme }) =>
    !theme.isTablet &&
    css`
      flex: 1;
    `}
`;

export default PdpGallery;
